export const PLATON_VERSIONS = ['PLATON_V1', 'PLATON_V2', 'PLATON_V3']
export const ENVIRONMENTS = ['DEV', 'PROD']
export const PROJECT_STATUSES = ['CREATED', 'ACTIVE', 'MAINTENANCE']
